import styled from 'styled-components';
import QuickBookSvg from '../../../assets/onboarding/newHome/quick-book.svg';

const QuickBookIcon = styled(QuickBookSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '4.2rem'};
height: ${props => props.height || '4.2rem'};
display: flex;
`;

export default QuickBookIcon;
